import { render, staticRenderFns } from "./ReferralPathwayTable.vue?vue&type=template&id=04e2c9ac&scoped=true"
import script from "./ReferralPathwayTable.vue?vue&type=script&lang=js"
export * from "./ReferralPathwayTable.vue?vue&type=script&lang=js"
import style0 from "./ReferralPathwayTable.vue?vue&type=style&index=0&id=04e2c9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2c9ac",
  null
  
)

export default component.exports